import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Modal,
  Typography,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"

type SimpleConfirmationProps = {
  open: boolean
  setOpen: any
  title: string
  optionalMessage?: any
  buttonText: string
  confirmActionHandler?: any
}

const SimpleConfirmation = ({
  open,
  setOpen,
  title,
  optionalMessage,
  buttonText,
  confirmActionHandler,
}: SimpleConfirmationProps) => {
  const handleClose = () => {
    setOpen()
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-modal"
      aria-describedby={title}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          borderRadius: "8px",
          transform: "translate(-50%, -50%)",
          width: 450,
          bgcolor: "#fff",
          boxShadow: 24,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            paddingBottom: "30px",
            paddingTop: "50px",
          }}
        >
          <ErrorOutlineIcon color="error" sx={{ fontSize: "50px" }} />
          <IconButton
            sx={{
              position: "absolute",
              top: 2,
              right: 2,
            }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: "bold",
              textAlign: "center",
              mx: "20px",
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              color: "#707070",
              textAlign: "center",
              mx: "20px",
            }}
          >
            {optionalMessage}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: confirmActionHandler ? "space-between" : "center",
            px: "20px",
          }}
        >
          {confirmActionHandler && (
            <Button
              variant="outlined"
              sx={{
                textTransform: "none",
                fontWeight: "bold",
                color: "#3366D6",
                px: "60px",
                display: "flex",
                mb: "30px",
                borderColor: "#3366D6",
              }}
              onClick={handleClose}
            >
              Cancel
            </Button>
          )}
          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              color: "#fff",
              px: "60px",
              display: "flex",
              mb: "30px",
            }}
            onClick={() => {
              confirmActionHandler()
              handleClose()
            }}
          >
            {buttonText}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default SimpleConfirmation
